import step1 from './step1.png';
import step2 from './step2.png';
import step3 from './step3.png';
import step4 from './step4.png';

export default {
  step1,
  step2,
  step3,
  step4,
};
